<template>
  <el-select
    :model-value="modelValue"
    :placeholder="placeholder"
    :clearable="clearable"
    :disabled="disabled"
    :loading="loading"
    filterable
    remote
    reserve-keyword
    :remote-method="onRemoteSearch"
    :style="selectStyle"
    @update:model-value="onChange"
    @visible-change="onVisible"
  >
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item.phone"
      :value="item.id"
    />
    <el-option
      v-if="hasMore"
      :value="__load_more__"
      disabled
      class="load-more-option"
    >
      <el-button link type="primary" :loading="loadingMore" @click.stop="loadMore">加载更多</el-button>
    </el-option>
  </el-select>
</template>

<script setup>
import { ref, watch } from 'vue'
import { request } from '../services/adminApi'

const props = defineProps({
  modelValue: { type: [Number, String], default: null },
  token: { type: String, required: true },
  placeholder: { type: String, default: '选择客户' },
  clearable: { type: Boolean, default: true },
  disabled: { type: Boolean, default: false },
  pageSize: { type: Number, default: 20 },
  width: { type: String, default: '180px' }
})

const emit = defineEmits(['update:modelValue', 'change', 'select'])

const options = ref([])
const loading = ref(false)
const loadingMore = ref(false)
const keyword = ref('')
const page = ref(1)
const total = ref(0)
const hasMore = ref(false)

const selectStyle = { width: props.width }
const LOAD_MORE = '__load_more__'

async function fetchPage(reset) {
  if (reset) {
    page.value = 1
    loading.value = true
  } else {
    loadingMore.value = true
  }
  try {
    const params = new URLSearchParams({
      page: String(page.value),
      size: String(props.pageSize)
    })
    if (keyword.value) params.set('keyword', keyword.value)
    const data = await request(`/api/admin/customer/list?${params}`, props.token)
    const rows = data?.records || []
    total.value = Number(data?.total || 0)
    const selectedId = props.modelValue
    const prevSelected = options.value.find((o) => o.id === selectedId)
    options.value = reset ? rows : [...options.value, ...rows]
    if (selectedId != null && !options.value.some((o) => o.id === selectedId) && prevSelected) {
      options.value = [prevSelected, ...options.value]
    }
    hasMore.value = options.value.length < total.value
  } finally {
    loading.value = false
    loadingMore.value = false
  }
}

function onRemoteSearch(query) {
  keyword.value = (query || '').trim()
  fetchPage(true)
}

function onVisible(open) {
  if (open && options.value.length === 0) {
    keyword.value = ''
    fetchPage(true)
  }
}

function loadMore() {
  if (!hasMore.value || loadingMore.value) return
  page.value += 1
  fetchPage(false)
}

function onChange(val) {
  if (val === LOAD_MORE) return
  const selected = options.value.find((o) => o.id === val) || null
  emit('update:modelValue', val)
  emit('change', val)
  emit('select', selected)
}

watch(
  () => props.modelValue,
  (id) => {
    if (id == null || options.value.some((o) => o.id === id)) return
    // 外部已有选中值但 options 为空时，占位；打开下拉会再拉全量
    options.value = [{ id, phone: String(id) }, ...options.value]
  },
  { immediate: true }
)
</script>

<style scoped>
.load-more-option {
  text-align: center;
}
</style>
